import { createSessionModule, nullOnUnauthorized } from '@nucleus-commerce/admin-kit/session';
import {
  getPlatformV1Me,
  postPlatformV1AuthLogout,
  type PlatformProfile,
} from '@nucleus-commerce/api-client/platform';

/** Platform staff session: /platform/v1/me with the user and their role. */
export const session = createSessionModule<PlatformProfile>({
  fetchMe: () => nullOnUnauthorized(getPlatformV1Me({ skipUnauthorizedHook: true })),
  logout: () => postPlatformV1AuthLogout({}),
});

export type Me = PlatformProfile;
